<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">{{ editing ? "Editar tipo de licencia" : "Nuevo tipo de licencia" }}</h1>
    </div>

    <form @submit.prevent="save" novalidate>
      <wz-card :title="editing ? 'Datos del tipo' : 'Datos del nuevo tipo'">
        <div class="flex flex-wrap -mx-2">
          <div class="w-full md:w-1/2 mb-3 px-2">
            <wz-input
              label="Nombre"
              required
              v-model="form.name"
              placeholder="Nombre del tipo de licencia"
              :error="$v.form.name.$error && !$v.form.name.required ? 'El nombre es requerido' : ''"
            />
          </div>
          <div class="w-full md:w-1/2 mb-3 px-2">
            <wz-input
              label="Código"
              required
              v-model="form.code"
              placeholder="Ej: PERMISO_INTERNO"
              :error="$v.form.code.$error && !$v.form.code.required ? 'El código es requerido' : ''"
            />
          </div>
          <div class="w-full md:w-1/2 mb-3 px-2">
            <label class="wz-form-label">Empresa <span class="text-danger">*</span></label>
            <wz-select
              :items="companyOptions"
              v-model="form.companyId"
              defaultOption="Seleccionar empresa"
            />
            <p v-if="$v.form.companyId.$error && !$v.form.companyId.required" class="wz-form-error-msg mt-1">
              La empresa es requerida
            </p>
          </div>
          <div class="w-full md:w-1/2 mb-3 px-2">
            <wz-input
              label="Días por defecto"
              type="number"
              v-model.number="form.defaultDays"
              min="0"
              placeholder="Ej: 3"
            />
          </div>
          <div class="w-full md:w-1/2 mb-3 px-2">
            <label class="wz-form-label">Remunerado</label>
            <wz-select :items="boolOptions" v-model="form.isRemunerated" />
          </div>
          <div class="w-full md:w-1/2 mb-3 px-2">
            <label class="wz-form-label">Requiere documentación</label>
            <wz-select :items="boolOptions" v-model="form.requiresDocumentation" />
          </div>
        </div>

        <div class="flex justify-end gap-2 mt-2">
          <wz-button variant="light" @click="$router.push({ name: 'leave-type-list' })">{{ editing ? "Volver" : "Cancelar" }}</wz-button>
          <wz-button type="submit" variant="primary" class="ml-2">Guardar</wz-button>
        </div>
      </wz-card>
    </form>
  </div>
</template>

<script>
import { Alert } from "@wizepe/wizeui"
import { required } from 'vuelidate/lib/validators'
import { LeaveTypeService, CompanyService } from '@/core/services'

export default {
  data() {
    return {
      editing: false,
      form: {
        name: null,
        code: null,
        companyId: null,
        defaultDays: null,
        isRemunerated: true,
        requiresDocumentation: false,
      },
      companyOptions: [],
      boolOptions: [
        { key: true, label: 'Sí' },
        { key: false, label: 'No' },
      ],
    }
  },
  validations: {
    form: {
      name: { required },
      code: { required },
      companyId: { required },
    },
  },
  methods: {
    async save() {
      this.$v.$touch()
      if (this.$v.$error) return
      try {
        this.$store.dispatch('app/loading', true)
        const data = {
          name: this.form.name,
          code: this.form.code,
          companyId: this.form.companyId,
          defaultDays: this.form.defaultDays,
          isRemunerated: this.form.isRemunerated,
          requiresDocumentation: this.form.requiresDocumentation,
        }
        if (!this.editing) await LeaveTypeService.save(data)
        else await LeaveTypeService.update(this.$route.params.id, data)
        Alert.success('Se almacenó la información correctamente')
        this.$router.push({ name: 'leave-type-list' })
      } catch (ex) {
        console.error(ex)
        Alert.error(ex.errors ? ex.errors.message : 'Error al guardar')
      } finally {
        this.$store.dispatch('app/loading', false)
      }
    },
    async load(id) {
      try {
        this.$store.dispatch('app/loading', true)
        const p = (await LeaveTypeService.get(id)).payload
        if (p.isLegal) {
          Alert.error('Los tipos de licencia legales no se pueden editar')
          this.$router.push({ name: 'leave-type-list' })
          return
        }
        this.form = {
          name: p.name,
          code: p.code,
          companyId: p.companyId,
          defaultDays: p.defaultDays,
          isRemunerated: p.isRemunerated,
          requiresDocumentation: p.requiresDocumentation,
        }
        this.editing = true
      } catch (e) {
        console.error(e)
        Alert.error(e.errors ? e.errors.message : 'Error al cargar')
        this.$router.push({ name: 'leave-type-list' })
      } finally {
        this.$store.dispatch('app/loading', false)
      }
    },
    async loadCompanies() {
      try {
        const resp = (await CompanyService.listAll()).payload || []
        this.companyOptions = resp.map(c => ({ key: c.id, label: c.name }))
      } catch (e) {
        console.error(e)
      }
    },
  },
  async created() {
    await this.loadCompanies()
    if (this.$route.params.id) this.load(this.$route.params.id)
  },
}
</script>
